import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Icon from '../../../../../../shared/components/ui/icons/Icon';
import iconsList from '../../../../../../shared/components/ui/icons/iconsList';
import classes from './MessageLine.module.css';

const MessageLine = ({ onOpen }) => {

    const endOfLineRef = useRef();
    const [value, setValue] = useState("");
    const { texts } = useSelector(state => state.translate);


    // const sendMessage = async () => {
    //     if (value === "")
    //         return;
    //     setValue("");
    //     await sendNewMessage(value);
    // };

    // const onKeyDown = event => {
    //     if (event.key === "Enter") {
    //         if (event.shiftKey) {
    //             return;
    //         }
    //         event.preventDefault();
    //         sendMessage();
    //     }
    // }

    return (
        <div className={classes.MessageLine} onClick={onOpen}>
            <div className={classes.InputWrapper}>
                <button type="button" className={classes.TextInput} onClick={onOpen}>
                    <span className={classes.TextLabel}>{texts.PostNewMessage}</span>
                    <Icon size="26px" className={classes.Send} name={iconsList.send} />
                </button>
            </div>
        </div>
    );
}

export default MessageLine;


